export default __webpack_public_path__ + "static/2-615f2f00380f41a4a556f2abecccfba6.jpeg";